import React, { FC, useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import _ from "lodash";

import long from "../../../assets/media/images/long.png";
import { NavLink, useLocation } from "react-router-dom";
import getLeftMenuData from "../../../areas/admin/menuItemsData";

export const Sider: FC = () => {
  const [collapsed, setCollapsed] = useState<boolean>(false);
  const [keys, setKeys] = useState<string[]>(
    [`${localStorage.getItem("app.menu.selectedKeys")}`] || []
  );

  const location = useLocation();
  const menu = getLeftMenuData();

  const handleClick = (e: any) => {
    localStorage.setItem("app.menu.selectedKeys", e.key);
    setKeys([e.key]);
  };

  useEffect(() => {
    setSelectedKeys();
  }, [collapsed]);

  const setSelectedKeys = () => {
    const flattenItems = (items: any, key: any) =>
      items.reduce((flattenedItems: any, item: any) => {
        flattenedItems.push(item);
        if (Array.isArray(item[key])) {
          return flattenedItems.concat(flattenItems(item[key], key));
        }
        return flattenedItems;
      }, []);

    const selectedItem = _.find(flattenItems(menu, "children"), [
      "url",
      location.pathname,
    ]);

    setKeys(selectedItem ? [selectedItem.id.toString()] : []);
  };

  return (
    <Layout.Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
      <a href="/">
        <div className="side-logo">
          <img src={long} alt="logo" />
        </div>
      </a>

      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={keys}
        onClick={handleClick}
      >
        {menu.map(({ url, title, Icon, id, children }: any) => {
          if (children) {
            return (
              <Menu.SubMenu title={title} key={id} icon={Icon && <Icon />}>
                {children.map(({ url, title, id }: any) => (
                  <Menu.Item key={id}>
                    <NavLink
                      className={(navData) =>
                        navData.isActive ? "active" : ""
                      }
                      to={url}
                    >
                      {title}
                    </NavLink>
                  </Menu.Item>
                ))}
              </Menu.SubMenu>
            );
          }

          return (
            <Menu.Item key={id} icon={<Icon />}>
              <NavLink
                className={(navData) => (navData.isActive ? "active" : "")}
                to={url}
              >
                {title}
              </NavLink>
            </Menu.Item>
          );
        })}
      </Menu>
    </Layout.Sider>
  );
};

export default Sider;
